import React from 'react';
import * as reactUtils from '../../packages/react-utils/react-utils.js';
import '@flixbus/honeycomb-icons-react';
import '../../packages/props-utils/prop-types.js';
import { requiredChildrenValidation } from '../../prop-types-validators/children-validator.js';

const legacyAutocompleteChildrenValidator = () => props => {
  const {
    children
  } = props;
  const requiredChildrenNames = ['LegacyAutocompleteInput', 'LegacyAutocompleteOptions'];
  const foundRequiredChildren = [];
  requiredChildrenNames.forEach(requiredChild => {
    const foundChild = React.Children.toArray(children).find(child => reactUtils.getElementName(child).includes(requiredChild));
    if (foundChild) {
      foundRequiredChildren.push(reactUtils.getUninjectedCompName(reactUtils.getElementName(foundChild)));
    }
  });
  if (foundRequiredChildren.length !== requiredChildrenNames.length) {
    return new Error('"LegacyAutocomplete" requires "children" of types "LegacyAutocompleteInput" and "LegacyAutocompleteOptions" to be provided.');
  }
  return requiredChildrenValidation(['LegacyAutocompleteInput', 'LegacyAutocompleteOptions', 'Injecss(LegacyAutocompleteSelectedOptions)'])(props, 'children', 'LegacyAutocomplete');
};

export { legacyAutocompleteChildrenValidator };
